import axios from 'axios'
import Api from './Api'
import {store} from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}
export default {
  async getAllCollectors () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collectors')
  },
  async getCollectorInfo () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_info?wd=true')
  },
  async getDrivers () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_drivers')
  },
  async getCcoDrivers (cloudSystemIds) {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/cco_drivers?cloud_system_ids=' + cloudSystemIds)
  },
  async getMonitors () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_monitors')
  },
  async saveAutoUpgrade (autoUpgrade) {
    return new Api().post('/admin/api/v1/orgs/' + getOrgId() + '/auto_upgrade', { autoUpgrade })
  },
  async getAutoUpgrade () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/auto_upgrade')
  },
  async getElkLogs(sourceId, pageSize, pageNumber, sortBy, sortAsc) {
    let filter = ''
    if (sourceId) {
      filter = '?source_id=' + sourceId
    }

    if (pageSize) {
      filter = filter + (filter ? '&' : '?')
      filter = filter + 'page_size=' + pageSize
    }

    if (pageNumber) {
      filter = filter + (filter ? '&' : '?')
      filter = filter + 'page_number=' + pageNumber
    }

    if (sortBy) {
      filter = filter + (filter ? '&' : '?')
      filter = filter + 'sort_by=' + sortBy
    }

    if ((sortAsc === true) || (sortAsc === false)) {
      filter = filter + (filter ? '&' : '?')
      filter = filter + 'sort_asc=' + sortAsc
    }

    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_elklogs' + filter)
    //collector_legacy_elklogs
  },
  async getRTLogs(systemId, pageSize, pageNumber) {
    return new Api().get('/admin/api/v1/realtime_elklogs?system_id=' + systemId
            + '&page_size=' + pageSize + '&page_number=' + pageNumber)
  },
  async getEndpointRTLogs(endpointId, pageSize, pageNumber) {
    return new Api().get('/admin/api/v1/realtime_elklogs?endpoint_id=' + endpointId
            + '&page_size=' + pageSize + '&page_number=' + pageNumber)
  },
  async getLogs (filter) {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_logs'+ (filter ? '?filter=' + filter : ''))
  },
  async getLogFiles () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_logfiles')
  },
  async getLogLevels () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_loglevels')
  },
  async saveLogLevels (collectorId, logLevels) {
    return new Api().post('/admin/api/v1/' + collectorId + '/log_levels', logLevels)
  },
  async getConfigFile(data) {
    return new Api().post('/admin/api/v1/orgs/' + getOrgId() + '/getConfigFile', data);
  },
  async downloadLogFile (collectorId, filename) {
    return new Api().get('/admin/api/v1/collector_logfiles/' + collectorId + '/' + filename)
  },
  async downloadFileFromS3(filename, version) {
    return new Api().get('/admin/api/v1/download/s3/' + filename + "?version=" + version);
  },
  async getMetrics (keylike) {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/collector_metrics' + (keylike ? '?keylike=' + keylike : ''))
  },
  async getWorkerSessions () {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/worker_sessions')
  },
  async getCollectorVersionFile(url) {
    return await axios.get(url)
  },
  async repoll(collectorId, collectorName, systemId) {
    return new Api().get('/admin/api/v1/collector_repoll/' + collectorId + '?collectorName=' + collectorName +
                        '&systemId=' + systemId)
  }
}
